module.exports = __webpack_public_path__ + "img/cea.2bcf107b.jpg";